module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/check/last-e543e3.svg";